export default __webpack_public_path__ + "static/firestick-hockey-226415a490ccbb6673e0ed6459d98ebe.jpg";